import { Settings } from '../app/app.settings';
import { Environment, getEnvironment } from './common';
import { devSettings } from './settings.dev';
import { locSettings } from './settings.loc';
import { prodSettings } from './settings.prod';
import { testSettings } from './settings.test';
import { uatSettings } from './settings.uat';

export type SettingsMap = Record<Environment, Settings>;

export const settingsMap: SettingsMap = {
  loc: locSettings,
  dev: devSettings,
  test: testSettings,
  uat: uatSettings,
  prod: prodSettings
};

export const settings: Settings = settingsMap[getEnvironment()];
